import "swiper/css";

import React, { useState } from "react";

import CommunitiesCard from "./CommunitiesCard";
import SliderSection from "./SliderSection";
import { SwiperSlide } from "swiper/react";
import communityImg1 from "../assets/cabraCerro.png";
import communityImg2 from "../assets/reco.png";
import communityImg3 from "../assets/challenge-3.png";
import { v4 } from "uuid";

// Import Swiper styles

const communitiesData = [
  {
    id: v4(),
    img: communityImg1,
    title: "Cabra de Cerro",
    category: "ONG",
    challengeCount: "2",
  },
  {
    id: v4(),
    img: communityImg2,
    title: "Cabra de Cerro",
    category: "ONG",
    challengeCount: "2",
  },
  {
    id: v4(),
    img: communityImg3,
    title: "Cabra de Cerro",
    category: "ONG",
    challengeCount: "2",
  },
  {
    id: v4(),
    img: communityImg3,
    title: "Cabra de Cerro",
    category: "ONG",
    challengeCount: "2",
  },
];

const Communities = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <SliderSection
      title={"Comunidades "}
      withArrows={true}
      sliderSectionStyle={{ height: "fit-content", marginBottom: "48px" }}
    >
      {communitiesData.map(({ id, img, title, category, challengeCount }) => (
        <SwiperSlide key={id} style={{ width: "fit-content" }}>
          <CommunitiesCard
            key={id}
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            img={img}
            title={title}
            category={category}
            challengeCount={challengeCount}
          />
        </SwiperSlide>
      ))}
    </SliderSection>
  );
};

export default Communities;
